<template>
    <div class="hours-header d-flex flex-wrap align-items-center justify-content-between p-3 mb-5">
        <div class="week-wrapper d-flex align-items-center">
            <button
                type="button"
                class="arrow-btn"
                @click="$emit('moveWeek', -1)"
            >
                <
            </button>
            <span class="week-number">Week {{ week }} / {{ year }}</span>
            <button
                type="button"
                class="arrow-btn"
                @click="$emit('moveWeek', 1)"
            >
                >
            </button>
            <span
                v-if="approvedHours !== null"
                class="approved-hours"
            >
                · {{ approvedHours }} approved {{ approvedHoursUnit }}
            </span>
        </div>
        <div class="hours-actions d-flex w-md-auto mt-2 mt-md-1">
            <button
                type="button"
                class="btn upload-btn"
                @click="triggerFileInput"
            >
                Import Hours
                <input
                    ref="fileInput"
                    type="file"
                    accept=".csv"
                    style="display: none"
                    @change="handleFile"
                />
            </button>
            
            <div class="hours-export d-flex">
                <select
                    id="formatSelect"
                    class="form-control"
                    v-model="selectedFormat"
                >
                    <option value="csv">.CSV</option>
                    <option value="xls">.XLS</option>
                </select>
                <span
                    class="export-guard"
                    :tabindex="exportBlockedReason ? 0 : null"
                    :aria-describedby="exportBlockedReason ? 'export-blocked-reason' : null"
                >
                    <button
                        type="button"
                        class="btn export-btn"
                        :disabled="Boolean(exportBlockedReason)"
                        @click="$emit('exportHours', selectedFormat)"
                    >
                        Export Hours
                    </button>
                    <span
                        v-if="exportBlockedReason"
                        id="export-blocked-reason"
                        role="tooltip"
                        class="export-blocked-reason"
                    >
                        {{ exportBlockedReason }}
                    </span>
                </span>
                <button
                    type="button"
                    class="btn export-btn"
                    @click="$emit('saveHours')"
                >
                    Save
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'HoursHeader',
        props: {
            exportBlockedReason: {
                type: String,
                default: null
            },
            year: {
                type: Number,
                require: true
            },
            week: {
                type: Number,
                require: true
            },
            approvedHours: {
                type: String,
                default: null
            }
        },
        data() {
            return{
                selectedFormat: 'csv'
            }
        },
        computed: {
            approvedHoursUnit() {
                return this.approvedHours === '1' ? 'hour' : 'hours';
            }
        },
        methods: {
            triggerFileInput() {
                this.$refs.fileInput.click()
            },
            handleFile(e) {
                const file = event.target.files[0];
                if (!file) return;

                const ok = /\.(csv|xlsx?)$/i.test(file.name);
                if (!ok) {
                    this.$toasted.global.failedRequest({ message: 'Please select a CSV or Excel file.' });
                    event.target.value = '';
                    return;
                }
                this.$emit('importHours', file)
            }
        }
    }
</script>
  
<style scoped>
    .hours-actions {
        gap: 2rem;
    }
    .hours-export {
        gap: 1rem;
    }
    .week-wrapper {
        gap: 1rem;
    }
    .week-number {
        font-size: 2rem;
        font-weight: 600;
        color: #146F70;
    }
    .approved-hours {
        font-size: 1.6rem;
        color: #6c757d;
    }
    /* Buttons */
    .arrow-btn {
        background-color: #FFF;
        border:none;
        font-size: 2rem;
        color: #8D97AD;
        font-weight: 600;
        cursor: pointer;
    }
    .hours-actions .btn {
        padding: 1rem 2rem;
        font-size: 1.6rem;
        border-radius: 10px;
        line-height: 1;
        color: #fff;
        font-weight: 600;
    }
    .hours-actions .upload-btn {
        background-color: #146F70;
        border: none;
    }
    .hours-actions .export-btn {
        background-color: #FF924E;
        border: none;
    }
    .hours-actions .upload-btn:hover {
        background-color: #126465;
    }
    .hours-actions .export-btn:hover {
        background-color: #E58346;
    }
    .export-guard {
        position: relative;
        display: inline-flex;
    }
    .hours-actions .export-btn:disabled {
        opacity: .5;
        cursor: not-allowed;
        pointer-events: none;
    }
    .export-blocked-reason {
        display: none;
        position: absolute;
        top: calc(100% + .6rem);
        right: 0;
        z-index: 10;
        width: max-content;
        max-width: 28rem;
        padding: .6rem 1rem;
        font-size: 1.3rem;
        line-height: 1.4;
        color: #FFF;
        background-color: #3B4252;
        border-radius: 6px;
    }
    .export-guard:hover .export-blocked-reason,
    .export-guard:focus .export-blocked-reason {
        display: block;
    }
</style>
  